import { createAction, props } from '@ngrx/store';
import { DocumentDetailsEntity } from './document-details.models';

export const initDocumentDetails = createAction(
  '[Document Details] Get document details',
  // docuLanguage is only kept in case a 301/category_ids redirect needs to rebuild the URL
  props<{ categoryId: number; documentId: number; language: string; docuLanguage?: string }>(),
);

// Dispatched for the 301 case: API responded with success:false and the correct category_ids for the document
export const redirectDocumentDetails = createAction(
  '[Document Details] Redirect Document Details',
  props<{ categoryId: number; documentId: number; language: string; docuLanguage?: string }>(),
);

export const clearDocumentDetails = createAction('[Document Details] Clear Document Details');

export const loadDocumentDetailsSuccess = createAction(
  '[Document Details] Load Document Details Success',
  props<{ documentDetails: DocumentDetailsEntity }>(),
);

export const loadDocumentDetailsFailure = createAction(
  '[Document Details] Load Document Details Failure',
  props<{ error: string }>(),
);
